import { Link } from 'react-router-dom';
import { usePortal } from '../lib/portal';
import '../styles/auth.css';

import { EnvBadge } from '../components/EnvBadge';
/**
 * Shown after a user signs out. Its whole job is to make the next step obvious
 * without anyone needing to touch the address bar: a clear confirmation and one
 * prominent way back to the public homepage, plus a way to sign in again.
 *
 * The session is already cleared by the time this renders (the sign-out handler
 * clears it first), so RequireAuth keeps every protected route closed — a back
 * button cannot reveal the app.
 */
export function LoggedOut() {
  const { siteHome } = usePortal();
  return (
    <div className="auth-wrap">
      <div className="auth-brand-row">
        <Link to={siteHome} className="auth-brand">NyumbaSuite</Link>
        <EnvBadge />
      </div>
      <div className="auth-card login" style={{ textAlign: 'center' }}>
        <div className="auth-mark" aria-hidden>✓</div>
        <h1 className="auth-title">You have been signed out</h1>
        <p className="auth-lede">Thanks for using NyumbaSuite. Head back to the homepage, or sign in again.</p>
        <Link className="btn btn-primary btn-block" to={siteHome}>Go to homepage</Link>
        <Link className="btn btn-secondary btn-block" to="/login" style={{ marginTop: 'var(--space-3)' }}>
          Sign in again
        </Link>
      </div>
    </div>
  );
}
